// Renders the project's recent activity as the design's vertical `.memory`
// timeline. Time labels are humanised from the ISO timestamps here so the
// server can keep emitting raw timestamps and the UI controls the format.

import type { JSX } from "react";

import type { ActivityEvent } from "@loom/shared/dashboard";

import { useT } from "../../i18n/index.js";
import { useRelativeTime } from "../../i18n/format.js";

interface ActivityBodyProps {
  readonly events: ReadonlyArray<ActivityEvent>;
  readonly loading: boolean;
  readonly error: string | null;
}

export const ActivityBody = ({
  events,
  loading,
  error,
}: ActivityBodyProps): JSX.Element => {
  const t = useT();
  const rel = useRelativeTime();
  if (loading) return <div className="memory"><p className="muted">{t("dashboard.activity.loading")}</p></div>;
  if (error !== null) {
    return (
      <div className="memory">
        <p className="form-error">{error}</p>
      </div>
    );
  }
  if (events.length === 0) {
    return (
      <div className="memory">
        <p className="muted">{t("dashboard.activity.empty")}</p>
      </div>
    );
  }
  return (
    <div className="memory">
      {events.map((e, i) => (
        <div key={`${e.at}-${i}`} className={`memory-item ${e.kind}`}>
          <div className="memory-time">{rel(e.at)}</div>
          <div className="memory-text">
            {e.text} <span className="actor">· {e.actor}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
